import { Reducer } from 'redux'

const ADD_SHOP_CONFIG = 'ADD_SHOP_CONFIG'

// TODO Add typing for CONFIG
type AddShopConfig = {
  type: typeof ADD_SHOP_CONFIG
  payload: object
}

export const addShopConfig = (payload: object): AddShopConfig => {
  return {
    type: ADD_SHOP_CONFIG,
    payload
  }
}

type ShopActions = AddShopConfig

const reducer: Reducer<{}> = (state: {} = {}, action: ShopActions): {} => {
  switch (action.type) {
    case ADD_SHOP_CONFIG:
      return {
        ...state,
        ...action.payload
      }
    default:
      return state
  }
}

export default reducer
